import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/ehbl/manifest'
import pathMap from 'src/paths/pathMap'

class EhblManifestRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.EHBL_MANIFEST_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.EHBL_MANIFEST_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.EHBL_MANIFEST_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.EHBL_MANIFEST_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default EhblManifestRoute
